import { render, staticRenderFns } from "./deleteDataPrivilege.vue?vue&type=template&id=0fd7c27e&scoped=true"
import script from "./deleteDataPrivilege.vue?vue&type=script&lang=js"
export * from "./deleteDataPrivilege.vue?vue&type=script&lang=js"
import style0 from "./deleteDataPrivilege.vue?vue&type=style&index=0&id=0fd7c27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd7c27e",
  null
  
)

export default component.exports